import { Guid } from '../../model/guid';
import { isItem } from '@ael/core-api';
import * as Immutable from 'immutable';
import {GetItemById} from '../../reducers/items/itemsSelectors';
import {ICompletionService} from '../../../features/tracking/services/CompletionService';

export interface ITrackingCompletionService {
  /** Return true, if every given item was completed by student. */
  areAllItemsCompleted(itemIds: Immutable.Set<Guid>): boolean;
}

export class TrackingCompletionService implements ITrackingCompletionService {
  constructor(private readonly getItem: GetItemById, private readonly completionService: ICompletionService) {}

  areAllItemsCompleted(itemIds: Immutable.Set<string>): boolean {
    return itemIds.every((itemId: Guid) => {
      const trackedItem = this.getItem(itemId);
      if (isItem(trackedItem)) {
        const isCompleted = this.completionService.isComplete(trackedItem);

        return isCompleted;
      }

      return true;
    });
  }
}
